import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { API } from 'constants';
import client from '../../services/cycle-api';

import useDocumentTitle from '../../hooks/useDocumentTitle';
import useCustomPagination from '../../hooks/useCustomPagination';
import { useDefaultSearchParams } from '../../hooks/useDefaultSearchParams';
import { useSwrPageRequestKeysManagingWithContextSaving } from '../../hooks/useSwrPageRequestKeysManagingWithContextSaving';

import { cyclesSortOptions, SORT_TYPES } from '../../constants/sort';

import CyclesIndexHeader from './CyclesIndexHeader/CyclesIndexHeader';
import CyclesIndexTopControls from './CyclesIndexTopControls/CyclesIndexTopControls';
import CyclesPaginatedContainer from './CyclesPaginatedContainer/CyclesPaginatedContainer';

const sortTypes = cyclesSortOptions.map(({ value }) => value);

const CraftCyclesIndexPage = () => {
    const [searchParams] = useSearchParams();

    const page = +searchParams.get('page') || '1';
    const sort = searchParams.get('sort') || SORT_TYPES.created;
    const search = searchParams.get('search');

    useDocumentTitle('CRAFT Cycles');

    useDefaultSearchParams({
        checkPage: true,
        checkSort: true,
        defaultSortType: SORT_TYPES.created,
        availableSortTypes: sortTypes,
    });

    const requestSearchParams = { ordering: sort };
    if (search) {
        requestSearchParams.query = search;
    }

    const cyclesHookResponse = useCustomPagination({
        client,
        route: API.ROUTES.cycle.cycle,
        pageIndex: page - 1,
        searchParams: requestSearchParams,
        autoFetchNextPage: true,
    });

    const { key, nextPageKey } = cyclesHookResponse;
    useSwrPageRequestKeysManagingWithContextSaving({ pageAccessor: 'cycles', key, nextPageKey });

    return (
        <div className="page-position bg-neutral-50 px-4 xs:px-5 pt-4 sm:px-6 sm:pt-6 md:px-8 md:pt-8 pb-[40px] overflow-y-auto flex flex-col gap-5">
            <CyclesIndexHeader />

            <CyclesIndexTopControls />

            <CyclesPaginatedContainer page={page} cyclesHookResponse={cyclesHookResponse} />
        </div>
    );
};

export default CraftCyclesIndexPage;
